import { useEffect, useMemo, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { parseLeadCaptureBotType } from "../modal/leadCaptureEmployeeOptions.js";

const DESKTOP_FOCUS_MIN_WIDTH = 768;

export function useLeadModalPrefill(isOpen, setEmail) {
  const [searchParams] = useSearchParams();
  const emailInputRef = useRef(null);
  const initialBotType = useMemo(() => {
    const fromBotType = parseLeadCaptureBotType(searchParams.get("bot_type"));
    if (fromBotType) return fromBotType;
    return parseLeadCaptureBotType(searchParams.get("lead_bot_type"));
  }, [searchParams]);

  useEffect(() => {
    const leadEmail = (searchParams.get("lead_email") || "").trim();
    if (leadEmail) {
      setEmail(leadEmail);
    }
  }, [searchParams, setEmail]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const isDesktop = window.matchMedia(`(min-width: ${DESKTOP_FOCUS_MIN_WIDTH}px)`).matches;
    if (!isDesktop) return undefined;

    const timer = window.setTimeout(() => {
      emailInputRef.current?.focus();
    }, 120);

    return () => window.clearTimeout(timer);
  }, [isOpen]);

  return { emailInputRef, initialBotType };
}
